import React, { useState } from "react"
import API from "../utils/API"
import Sweetalert from "../utils/Sweetalert"

export default function DisplayManageDetailsForm({ display, updateDisplay, setEditDisplay }) {
  const [agency, setAgency] = useState(display.agency || "")
  const [code, setCode] = useState(display.code || "")
  const [address, setAddress] = useState(display.address || "")
  const [city, setCity] = useState(display.city || "")
  const [zipCode, setZipCode] = useState(display.zip_code || "")
  const [format, setFormat] = useState(display.format || "")
  const [indoor, setIndoor] = useState(display.indoor || "")
  const [position, setPosition] = useState(display.position || "")
  const [type, setType] = useState(display.type || "")
  const [audience, setAudience] = useState(display.audience || "")
  const [spot, setSpot] = useState(display.spot || "")
  const [diffusion, setDiffusion] = useState(display.diffusion || "")
  const [lat, setLat] = useState(display.lat || "")
  const [long, setLong] = useState(display.long || "")
  const [price1, setPrice1] = useState(display.price_1 || "")
  const [price2, setPrice2] = useState(display.price_2 || "")
  const [price3, setPrice3] = useState(display.price_3 || "")
  const [tlpe, setTlpe] = useState(display.tlpe || "")
  const [sector, setSector] = useState(display.sector || "")
  const [zoneType, setZoneType] = useState(display.zone_type || "")
  const [commercial, setCommercial] = useState(display.commercial || "")
  const [tel, setTel] = useState(display.tel || "")
  const [description, setDescription] = useState(display.description || "")
  const [imageUrl, setImageUrl] = useState(display.image_url || "")
  const [error, setError] = useState("")

  const handleSubmit = (event) => {
    event.preventDefault()
    setError("")

    Sweetalert.fireConfirm("Validez-vous cette mise à jour ?", "", () => {
      let data = {
        agency: agency || null,
        code: code || null,
        address: address || null,
        city: city || null,
        zip_code: zipCode || null,
        format: format || null,
        indoor: indoor || null,
        position: position || null,
        type: type || null,
        audience: audience || null,
        spot: spot || null,
        diffusion: diffusion || null,
        lat: lat || null,
        long: long || null,
        price_1: price1 || null,
        price_2: price2 || null,
        price_3: price3 || null,
        tlpe: tlpe || null,
        sector: sector || null,
        zone_type: zoneType || null,
        commercial: commercial || null,
        tel: tel || null,
        description: description || null,
        image_url: imageUrl || null,
      }

      API.PUT("/admin/display/" + display.id, data, (response) => {
        Sweetalert.fireSuccessToast(response.data.message)
        updateDisplay(data)
        setEditDisplay(false)
      })
    })
  }

  // Rendu
  return (
    <div className="card card-light">
      <div className="card-header">
        <h3 className="card-title">Édition de l'emplacement : {display.code}</h3>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="card-body">
          <h5 className="mb-3">Informations de l'emplacement</h5>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>Agence</label>
                <input type="text" className="form-control" placeholder="Agence" value={agency} onChange={(event) => setAgency(event.target.value)} />
              </div>
              <div className="form-group">
                <label>Code *</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Code"
                  value={code}
                  required
                  onChange={(event) => setCode(event.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Adresse</label>
                <input type="text" className="form-control" placeholder="Adresse" value={address} onChange={(event) => setAddress(event.target.value)} />
              </div>
              <div className="form-group">
                <label>Ville</label>
                <input type="text" className="form-control" placeholder="Ville" value={city} onChange={(event) => setCity(event.target.value)} />
              </div>
              <div className="form-group">
                <label>Code postal</label>
                <input type="text" className="form-control" placeholder="Code postal" value={zipCode} onChange={(event) => setZipCode(event.target.value)} />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Format</label>
                <select className="form-control" value={format} onChange={(event) => setFormat(event.target.value)}>
                  <option value="">-- Sélectionner un format --</option>
                  <option value="1m2">1m2</option>
                  <option value="2m2">2m2</option>
                  <option value="4m2">4m2</option>
                  <option value="6m2">6m2</option>
                  <option value="8m2">8m2</option>
                  <option value="12m2">12m2</option>
                </select>
              </div>
              <div className="form-group">
                <label>Indoor</label>
                <input type="text" className="form-control" placeholder="Indoor" value={indoor} onChange={(event) => setIndoor(event.target.value)} />
              </div>
              <div className="form-group">
                <label>Position</label>
                <input type="text" className="form-control" placeholder="Position" value={position} onChange={(event) => setPosition(event.target.value)} />
              </div>
              <div className="form-group">
                <label>Type</label>
                <select className="form-control" value={type} onChange={(event) => setType(event.target.value)}>
                  <option value="">-- Sélectionner un type --</option>
                  <option value="Digital">Digital</option>
                  <option value="Impression">Impression</option>
                </select>
              </div>
              <div className="form-group">
                <label>Audience</label>
                <input type="text" className="form-control" placeholder="Audience" value={audience} onChange={(event) => setAudience(event.target.value)} />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Spot</label>
                <input type="text" className="form-control" placeholder="Spot" value={spot} onChange={(event) => setSpot(event.target.value)} />
              </div>
              <div className="form-group">
                <label>Diffusion</label>
                <input type="text" className="form-control" placeholder="Diffusion" value={diffusion} onChange={(event) => setDiffusion(event.target.value)} />
              </div>
              <div className="form-group">
                <label>TLPE</label>
                <input type="text" className="form-control" placeholder="TLPE" value={tlpe} onChange={(event) => setTlpe(event.target.value)} />
              </div>
              <div className="form-group">
                <label>Secteur</label>
                <select className="form-control" value={sector} onChange={(event) => setSector(event.target.value)}>
                  <option value="">-- Sélectionner un secteur --</option>
                  <option value="Casino">Casino</option>
                  <option value="Centre ville">Centre ville</option>
                  <option value="Cinema">Cinema</option>
                  <option value="Grande surface">Grande surface</option>
                  <option value="Routier">Routier</option>
                  <option value="Tennis club">Tennis club</option>
                  <option value="Village vacances">Village vacances</option>
                </select>
              </div>
              <div className="form-group">
                <label>Type de zone</label>
                <input type="text" className="form-control" placeholder="Type de zone" value={zoneType} onChange={(event) => setZoneType(event.target.value)} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label>Latitude</label>
                <input type="number" step="any" className="form-control" placeholder="Latitude" value={lat} onChange={(event) => setLat(event.target.value)} />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Longitude</label>
                <input type="number" step="any" className="form-control" placeholder="Longitude" value={long} onChange={(event) => setLong(event.target.value)} />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Commercial</label>
                <input type="text" className="form-control" placeholder="Commercial" value={commercial} onChange={(event) => setCommercial(event.target.value)} />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Téléphone</label>
                <input type="text" className="form-control" placeholder="Téléphone" value={tel} onChange={(event) => setTel(event.target.value)} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>Prix 1</label>
                <input type="number" step="0.01" className="form-control" placeholder="Prix 1" value={price1} onChange={(event) => setPrice1(event.target.value)} />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Prix 2</label>
                <input type="number" step="0.01" className="form-control" placeholder="Prix 2" value={price2} onChange={(event) => setPrice2(event.target.value)} />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Prix 3</label>
                <input type="number" step="0.01" className="form-control" placeholder="Prix 3" value={price3} onChange={(event) => setPrice3(event.target.value)} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Description</label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Description de l'emplacement"
                  value={description}
                  onChange={(event) => setDescription(event.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>URL de l'image</label>
                <input
                  type="url"
                  className="form-control"
                  placeholder="https://exemple.com/image.jpg"
                  value={imageUrl}
                  onChange={(event) => setImageUrl(event.target.value)}
                />
              </div>
            </div>
          </div>
          <p className="text-danger">{error}</p>
        </div>
        <div className="card-footer">
          <button type="submit" className="btn btn-primary">
            Valider
          </button>
          <button type="button" className="btn btn-default float-right" onClick={() => setEditDisplay(false)}>
            Annuler
          </button>
        </div>
      </form>
    </div>
  )
}
